import {
  MessageSquare,
  Users,
  KanbanSquare,
  Gauge,
  Workflow,
  Layers,
  Cloud,
  Radio,
  TrendingUp,
} from "lucide-react";

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Solutions", href: "#solutions" },
  { label: "Why Lark", href: "#why" },
  { label: "Global", href: "#global" },
  { label: "Contact", href: "#contact" },
];

export const SOLUTIONS = [
  {
    icon: Users,
    title: "Workplace Collaboration",
    desc: "Bring teams, docs, and conversations into one shared surface where work actually happens.",
  },
  {
    icon: MessageSquare,
    title: "Communication",
    desc: "Messaging, video, and calls unified so distributed teams stay perfectly in sync.",
  },
  {
    icon: KanbanSquare,
    title: "Project Management",
    desc: "Plan, track, and ship with boards and timelines built for enterprise velocity.",
  },
  {
    icon: Gauge,
    title: "Enterprise Productivity",
    desc: "Automations and integrations that remove busywork and compound output.",
  },
  {
    icon: Workflow,
    title: "Business Workflows",
    desc: "Model approvals, requests, and operations into workflows that run themselves.",
  },
];

export const FEATURES = [
  {
    icon: Layers,
    title: "Integrated Collaboration",
    desc: "Chat, docs, meetings, and calendar in one connected fabric — no context switching.",
  },
  {
    icon: TrendingUp,
    title: "Enterprise Productivity",
    desc: "Purpose-built tooling that scales with the ambition of the organizations we serve.",
  },
  {
    icon: Cloud,
    title: "Cloud-Based Solutions",
    desc: "Secure, always-available infrastructure accessible from anywhere on any device.",
  },
  {
    icon: Radio,
    title: "Seamless Communication",
    desc: "Real-time and asynchronous channels that keep every stakeholder aligned.",
  },
  {
    icon: Gauge,
    title: "Scalable Technology",
    desc: "Architecture engineered to grow from a single team to a global enterprise.",
  },
];

export const MARQUEE_ITEMS = [
  "Workplace Collaboration",
  "Cloud Infrastructure",
  "Seamless Communication",
  "Enterprise Productivity",
  "Business Workflows",
  "Scalable Technology",
  "Project Management",
];

export const STATS = [
  { value: "10M+", label: "Active users worldwide" },
  { value: "150+", label: "Countries reached" },
  { value: "99.9%", label: "Platform uptime" },
  { value: "24/7", label: "Enterprise support" },
];

export const IMAGES = {
  heroAbstract:
    "https://images.unsplash.com/photo-1557683316-973673baf926?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  singapore:
    "https://images.unsplash.com/photo-1774075884764-be7319c06e08?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  team:
    "https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  team2:
    "https://images.unsplash.com/photo-1572021335469-31706a17aaef?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};
